<template>
  <div>
    <table-list
        ref="table"
        idKey="planId"
        :listConfig="listConfig"
        :searchConfig="searchConfig"
        :apis="apis"
        :createFrom="fromConfig"
        :btn-config="btnConfig"
        @handleBtn="handleBtn"
        @cellDblclick="cellDblclick"
        :btnConfig="btnConfig | filterBtnsRole($route)"
    >
    </table-list>
    <from-list :fromConfig="submitConfig" ref="submit" @confirm="submitConfirm"></from-list>
    <from-list :fromConfig="rejectConfig" ref="reject" @confirm="rejectConfirm"></from-list>
    <from-list ref="remark" :fromConfig="remarkConfig" @confirm="remarkConfirm"/>
    <detail-list ref="detail" :detailConfig="detailConfig" :detailApi="apis.detail">
      <div style="padding: 0 104px;" slot="box_operation_record" slot-scope="data">
        <el-table
            style="width: 99.9%"
            header-align="center"
            align="center"
            :data="data.from.value">
          <el-table-column
              header-align="center"
              align="center"
              prop="operation"
              label="操作">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="operationTime"
              label="操作时间">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="operatorName"
              label="操作人">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="money"
              label="结算金额">
          </el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px;" slot="box_operation_remark" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="date" label="时间"></el-table-column>
          <el-table-column header-align="center" align="center" prop="operatorName" label="备注人"></el-table-column>
          <el-table-column header-align="center" align="center" prop="remark" label="备注内容"></el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px;" slot="box_operation_jieRecord" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="statusJie" label="结算状态">
            <template slot-scope="scope">{{
                scope.row.statusJie === 1 ? '未结算' :
                    scope.row.statusJie === 2 ? '审核中' :
                        scope.row.statusJie === 3 ? '已通过' :
                            scope.row.statusJie === 4 ? '部分结算' :
                                scope.row.statusJie === 5 ? '已结算' : ''
              }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="jieTime" label="打款时间"></el-table-column>
          <el-table-column header-align="center" align="center" prop="jieType" label="结算类型">
            <template slot-scope="scope">{{
                scope.row.jieType === 1 ? '全部结算' :
                    scope.row.jieType === 2 ? '部分结算' : ''
              }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="jieMoney" label="结算金额"></el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px" slot="box_operation_orderRunTrackList" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="runstateName" label="操作"/>
          <el-table-column header-align="center" align="center" prop="createTime" label="时间"/>
          <el-table-column header-align="center" align="center" prop="orientation" label="地址"/>
          <el-table-column header-align="center" align="center" prop="remark" label="备注内容"/>
          <el-table-column header-align="center" align="center" prop="remark" label="照片">
            <template slot-scope="{row}">
              <div style="display: inline-grid;">
                <el-image v-if="row.images" v-for="item in row.images.split(',')"
                          :src="item"
                          :preview-src-list="[item]"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </detail-list>
  </div>
</template>

<script>
import config from './config/list.config'
import {road} from '@/api/public'
import {SetRemark} from "@/api/finance";

export default {
  data() {
    return {
      roadList: [],
      searchConfig: [],
      submitConfig: [],
      remarkConfig: [],
      rejectConfig: [],
      ...config()
    }
  },
  created() {
    this.createConfig()
  },
  methods: {
    cellDblclick(row) {
      this.$refs.detail.getDtail(row.planId);
    },
    createConfig() {
      Promise.all([road()]).then(([road, driver]) => {
        this.roadList = road.data.map(item => ({...item, label: item.name, value: item.roadId}));
        this.searchConfig = this.createSearch(this.roadList);
      })
    },
    handleBtn(key, list) {
      if (key === 'submit') {
        if (list.length < 1) this.$error('请选择一项操作');
        this.submitConfig = this.createSubmit();
        this.$refs[key].open(null, {ids: list.map(x => x.planId)})
      } else if (key === "remark") {
        if (list.length !== 1) this.$error('请选择一条运单')
        this.remarkConfig = this.createRemark();
        this.$refs[key].open(list[0], {planId: list[0].planId})
      } else {
        if (list.length === 0) this.$error('请选择一项操作');
        this.rejectConfig = this.createReject();
        this.$refs[key].open(null, { ids: list.map(x => x.planId) })
      }
    },
    async remarkConfirm(data) {
      const params = this.$params(this.remarkConfig);
      const [res] = await this.$ajax(SetRemark, {...params, ...data});
      if (res.data) {
        this.$refs.remark.close();
        this.$refs.table.getList();
      }
    },
    async submitConfirm(data) {
      const params = this.$params(this.submitConfig);
      const [res] = await this.$ajax(this.apis.orderSubmit, {...params, ...data});
      if (res) {
        this.$refs.submit.close();
        this.$refs.table.getList();
      }
    },
    async rejectConfirm(data) {
      const params = this.$params(this.rejectConfig);
      const [res] = await this.$ajax(this.apis.orderReject, {...params, ...data});
      if (res) {
        this.$refs.reject.close();
        this.$refs.table.getList();
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
